
import { defineComponent, SetupContext, computed } from "vue";
import NativeClient from "@/client/native-client";
import { PantryImageSelectData } from "@/types/pantry";

export default defineComponent({
  name: "PantryImageSelectItem",
  components: {
  },
  props: {
    data: {
      type: PantryImageSelectData,
      default: null
    },
    selectRoomId: {
      type: Number,
      default: 0,
      require: true
    }
  },
  setup(props, context: SetupContext) {
    const getTitle = () => {
      let result = "";
      if (props.data && props.data.name) {
        result = props.data.name;
      }
      return result;
    };
    const onClickRoom = () => {
      const id = (props.data) ? props.data.id : -1;
      if (id != -1) {
        context.emit("select-room", props.data.id);
      }
    };
    const isActive = () => {
      return (props.data && props.data.id == props.selectRoomId);
    };
    const styleText = () => {
      return isActive() ? "bold" : "normal";
    };
    return {
      getTitle,
      isActive,
      styleText,
      onClickRoom
    };
  }
});
